import Cookies from "js-cookie";
import imagesLoaded from "imagesloaded";

let view;
let value;

const getViewerValue = function () {
    let viewerValue = Cookies.get("MM_viewer");
    if (typeof viewerValue == "undefined") {
        viewerValue = window.site_settings.defaults.viewerValue;
    }
    viewerValue = correctForMobile(viewerValue);
    console.log(`Initialized with Level ${viewerValue}`);
    return viewerValue;
};

const setViewerValue = function (viewerValue) {
    if (viewerValue <= 5) {
        document.body.setAttribute("data-mm-zoom-level", viewerValue);
        Cookies.set("MM_viewer", viewerValue, { expires: 365 });
    }
};

const viewerValueSetCallback = function (viewerValue) {
    if (window.isoT) {
        window.isoT.layout();
    }
    if (view == "singular") {
        document.location.href = site_settings.home;
    }

    if (view == "overview" && viewerValue < 5) {
        document.body.classList.remove("body--light");
    }

    let first = null;
    if (view == "overview" && viewerValue == 6) {
        var io = new IntersectionObserver(
            (entries) => {
                if (first == null) {
                    entries.every(function (elem) {
                        console.log(elem);
                        if (elem.intersectionRatio > 0.5) {
                            first = elem.target;
                            return false;
                        }
                        return true;
                    });
                }
                if (first != null) {
                    document.location.href = first.getAttribute("data-link");
                }
            },
            {
                /* Using default options. Details below */
            }
        );

        document.querySelectorAll("article").forEach(function (el) {
            io.observe(el);
        });
    }
};

export const misterMotleyViewer = function (el) {
    view = el.getAttribute("data-view");
    if (view == "overview") {
        const viewerValue = getViewerValue();
        value = viewerValue;
        el.value = viewerValue * 1000;
        setViewerValue(viewerValue);
    }
    const changeCallback = function () {
        let newValue = Math.round(parseInt(this.value) / 1000);
        newValue = correctForMobile(newValue);

        if (newValue != value) {
            value = newValue;
            setViewerValue(newValue);
            viewerValueSetCallback(newValue);
        }
    };

    const snapCallback = function () {
        let newValue = Math.round(parseInt(this.value) / 1000);
        newValue = correctForMobile(newValue);
        el.value = newValue * 1000;
    };

    el.addEventListener("input", changeCallback);
    el.addEventListener("change", changeCallback);
    el.addEventListener("change", snapCallback);
};

const correctForMobile = function (value) {
    if (window.innerWidth < 480) {
        if (value == 2) {
            value = 1;
        }
        if (value == 5 || value == 3) {
            value = 4;
        }
    }

    return value;
};

function visible(elem) {
    return !(elem.clientHeight === 0 || elem.clientWidth === 0);
}

export const misterMotleyArticleActions = function (el) {
    el.addEventListener("mouseenter", function () {
        if (document.body.getAttribute("data-mm-zoom-level") == "5") {
            if (el.classList.contains("article--theme-light")) {
                document.body.classList.add("body--light");
            } else {
                document.body.classList.remove("body--light");
            }
        }
    });
};

export const misterMotleyFixOldArticles = function (el) {
    el.querySelectorAll(".media-element-container").forEach(function (sub_el) {
        if (
            sub_el.nextElementSibling &&
            sub_el.nextElementSibling.nodeName == "P" &&
            sub_el.nextElementSibling.innerHTML == "&nbsp;"
        ) {
            sub_el.nextElementSibling.remove();
        }
        if (
            sub_el.nextElementSibling &&
            sub_el.nextElementSibling.classList.contains(
                "field-file-image-title-text"
            )
        ) {
            sub_el.style.marginBottom = "0px";
        }
    });
};

export const observeArticles = function (el) {
    window.io = new IntersectionObserver(
        (entries) => {
            let largest = 0;
            let selectedArticle = null;
            entries.forEach(function (elem) {
                console.log(elem);
                if (elem.isIntersecting) {
                    selectedArticle = elem.target;
                }
            });

            document.querySelectorAll("article").forEach(function (subEl) {
                subEl.classList.remove("single-article--active");
            });
            selectedArticle.classList.add("single-article--active");

            if (selectedArticle) {
                console.log(
                    "URL",
                    selectedArticle.getAttribute("data-push-url")
                );
                window.history.pushState(
                    null,
                    selectedArticle.querySelector("h1").innerText,
                    selectedArticle.getAttribute("data-push-url")
                );
            }
        },
        { rootMargin: "-50% 0px -50% 0px" }
    );
};

export const articleInView = function (el) {
    window.io.observe(el);
};

const overrideText = function (el) {
    console.log(el);
    el.querySelectorAll(".favorite-button__status").forEach(function (subEl) {
        subEl.innerText = "Verwijderen";
    });

    el.querySelectorAll(".favorite-button__icon").forEach(function (subEl) {
        console.log(subEl);
        subEl.innerHTML =
            '<svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="70" height="70" fill="transparent"/><path d="M15 15L55 55M15 55L55 15" stroke="black" stroke-width="5"/></svg>';
    });
};

export const misterMotleyRemoveFavorite = function (el) {
    jQuery(document).on(
        "favorites-user-favorites-loaded",
        function (event, favorites, initialLoad) {
            setTimeout(function () {
                overrideText(el);
            }, 100);
            console.log("updated", favorites);
        }
    );

    jQuery(document).on(
        "favorites-updated-single",
        function (event, favorites, initialLoad) {
            console.log("Test", initialLoad);

            document.querySelector("[data-id='" + initialLoad + "']").remove();
            if (window.isoT) {
                window.isoT.layout();
            }

            setTimeout(function () {
                overrideText(el);
            }, 100);
        }
    );
};

export const misterMotleyAds = function (el) {
    console.log("init mistermotley ");
    imagesLoaded(el, function () {
        console.log("ads images loaded");

        if (window.isoT) {
            console.log("masonry layout, after ads images loaded");
            window.isoT.layout();
        }
    });
};

export const removeFilter = function (el) {
    const name = el.getAttribute("data-name");
    document.querySelector(
        `.searchandfilter [data-sf-field-name="${name}"] select`
    ).selectedIndex = 0;
    jQuery(`[data-sf-field-name="${name}"] select`).trigger("change");
    el.remove();
};

export const closeOverlay = function (el) {
    document.body.classList.remove("plans-overlay--active");
    document.body.classList.remove("newsletter-overlay--active");
};

export const filterInit = function (el) {
    jQuery(document).on("sf:ajaxstart", ".searchandfilter", function () {
        console.log("ajax start");
    });
};

window.viewedArticles = false;
export const countViewedArticles = function (el) {
    console.log(">>>Counting ");
    if (!window.site_settings.loggedin) {
        if (
            !window.viewedArticles &&
            typeof Cookies.get("MM_viewed_articles") == "undefined"
        ) {
            window.viewedArticles = 0;
            console.log(">>>Counting = 0");
        } else {
            window.viewedArticles = parseInt(
                Cookies.get("MM_viewed_articles"),
                10
            );
            console.log(">>>Counting existed");
        }
        window.viewedArticles++;
        console.log(">>>Counting added ", window.viewedArticles);

        Cookies.set("MM_viewed_articles", window.viewedArticles, {
            expires: 7,
        });

        if (
            window.viewedArticles >= 2 &&
            typeof Cookies.get("MM_popup_shown") == "undefined"
        ) {
            Cookies.set("MM_popup_shown", "yes", {
                expires: 7,
            });
            document.body.classList.add("plans-overlay--active");
        }
    }
};

export const popupProductLink = function (el, evt) {
    evt.preventDefault();

    const id = document.querySelector(
        ".plans-overlay .overlay__slider input"
    ).value;
    const url = document
        .querySelectorAll(".plans-overlay .overlay__plan")
        [id - 1].getAttribute("href");

    window.location.href = url;
};

export const showNewsletter = function (el) {
    el.addEventListener("click", function () {
        document.body.classList.add("newsletter-overlay--active");
    });
};
